import React from "react";
import {
  Pagination,
  download,
  SelectInput,
  SearchInput,
  searchIcon,
} from "../../Components";
import BillingItem from "./BillingItem";
export default function AccountTransactionDetail({
  searchString,
  disableSearchBox,
  search,
  setSearchStringText,
  changeMediumDesc,
  selectDescList,
  setModalBill,
  setModalDataBill,
  onPaginate,
  paginationData,
  transactionDetails,
  setModalAddToken,
  downloadCsv,
}) {
  console.log(
    "🚀 ~ AccountTransactionDetail ~ transactionDetails:",
    transactionDetails
  );
  return (
    <>
      <div className="billing__table-title">
        <h4>Transaction details</h4>
        <div className="billing__table-title-inner">
          <SelectInput
            list={selectDescList}
            selected={selectDescList[0]}
            onChange={changeMediumDesc}
          />
          <SearchInput
            type="text"
            icon={searchIcon}
            placeholder="Search"
            onClick={search}
            onChange={setSearchStringText}
            value={searchString}
            disable={disableSearchBox}
          />
        </div>
      </div>
      <div>
        <div>
          <div className="billing__table !rounded-lg">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Description</th>
                  <th>Payment method</th>
                </tr>
              </thead>
              <tbody>
                {transactionDetails?.length > 0 ? (
                  <>
                    {transactionDetails?.map((item, index) => {
                      return (
                        <BillingItem
                          onClick={() => {
                            setModalBill("transaction");
                            setModalDataBill(item);
                          }}
                          key={index}
                          {...item}
                        />
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No records
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="billing__table-footer">
            <button className="button tertiary download" onClick={downloadCsv}>
              Download CSV {download}
            </button>
            {transactionDetails.length > 0 && (
              <Pagination
                perPage={paginationData["per_page"]}
                total={paginationData["total"]}
                currentPage={paginationData["current_page"]}
                totalPages={paginationData["total_pages"]}
                onPaginate={onPaginate}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
